module.exports = __webpack_public_path__ + "static/media/halloween10.6d3d35fa.jpg";